import { HttpResponse1532ob1hsse1y as HttpResponse } from './HttpResponse.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  Companion_getInstance16dzvgcii8pc4 as Companion_getInstance,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpResponseClass;
function DefaultHttpResponse() {
  if (DefaultHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, responseData) {
        super();
        this.s63_1 = call;
        this.t63_1 = responseData.c5p_1;
        this.u63_1 = responseData.x5o_1;
        this.v63_1 = responseData.a5p_1;
        this.w63_1 = responseData.y5o_1;
        this.x63_1 = responseData.d5p_1;
        var tmp = this;
        var tmp_0 = responseData.b5p_1;
        var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel()) ? tmp_0 : null;
        tmp.y63_1 = tmp0_elvis_lhs == null ? Companion_getInstance().s4o_1 : tmp0_elvis_lhs;
        this.z63_1 = responseData.z5o_1;
      }
      i5o() {
        return this.s63_1;
      }
      gw() {
        return this.t63_1;
      }
      r5o() {
        return this.u63_1;
      }
      s5o() {
        return this.v63_1;
      }
      t5o() {
        return this.w63_1;
      }
      u5o() {
        return this.x63_1;
      }
      q5o() {
        return this.y63_1;
      }
      v55() {
        return this.z63_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpResponse');
    DefaultHttpResponseClass = $;
  }
  return DefaultHttpResponseClass;
}
//region block: exports
export {
  DefaultHttpResponse as DefaultHttpResponse2wnrinzo0twhn,
};
//endregion

//# sourceMappingURL=DefaultHttpResponse.mjs.map
